import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LadderRungView, LadderView } from '../../models/achievement.model';

/**
 * Ladder detail overlay. Centred dialog on desktop, bottom sheet on mobile —
 * one template, the breakpoint only changes the chrome.
 */
@Component({
  selector: 'app-ladder-detail-sheet',
  templateUrl: './ladder-detail-sheet.component.html',
  styleUrls: ['./ladder-detail-sheet.component.scss']
})
export class LadderDetailSheetComponent {
  @Input() ladder: LadderView;
  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.closed.emit();
  }

  trackByRungKey(index: number, rung: LadderRungView): string {
    return rung.key;
  }
}
